import { render, staticRenderFns } from "./listOne1.vue?vue&type=template&id=5422f21c&scoped=true&"
import script from "./listOne1.vue?vue&type=script&lang=js&"
export * from "./listOne1.vue?vue&type=script&lang=js&"
import style0 from "./listOne1.vue?vue&type=style&index=0&id=5422f21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422f21c",
  null
  
)

export default component.exports